interface UserInitialsAvatarProps {
  firstName: string;
  lastName: string;
}

export function UserInitialsAvatar({
  firstName,
  lastName,
}: UserInitialsAvatarProps) {
  const initials =
    `${firstName.trim()[0] ?? ""}${lastName.trim()[0] ?? ""}`.toUpperCase() ||
    "?";
  return (
    <div
      aria-hidden="true"
      className="w-7 h-7 rounded-full bg-surface-2 flex items-center justify-center text-[11px] font-semibold text-text-soft"
    >
      {initials}
    </div>
  );
}
